<script setup lang="ts">import { computed as _computed } from 'vue';

import { baseUrl } from '@/utils/config'
import { Btn } from '@bagelink/vue'
import { useRoute } from 'vue-router'

const props = defineProps<{ title?: string, imageUrl?: string }>()
const route = useRoute()

const path = `${baseUrl}/${route.fullPath}`
const socialItems = _computed(() => {
	return [
		{ icon: 'facebook-f', href: `https://www.facebook.com/sharer.php?u=${path}&t=${props.title}` },
		{ icon: 'x-twitter', href: `https://twitter.com/intent/tweet?url=${path}&text=${props.title}` },
		{ icon: 'linkedin-in', href: `https://www.linkedin.com/shareArticle?url=${path}&title=${props.title}` },
		{ icon: 'email', href: `mailto:?subject=${props.title}&body=${path} \n${props.title}` },
		{ icon: 'whatsapp', href: `https://api.whatsapp.com/send?text=${path}\n${props.title}` },
		// { icon: 'telegram', href: `https://t.me/share/url?url=${path}&text=${props.title}` },
		// { icon: 'reddit', href: `https://www.reddit.com/submit?url=${path}&title=${props.title}` },
		// { icon: 'pinterest', href: `https://www.pinterest.com/pin/create/button/?url=${path}&description=${props.title}` },
	]
})
</script>

<template>
	<div class="flex gap-1 m_gap-05  m_flex-wrap">
		<Btn
			v-for="{ icon, href } in socialItems" :key="href"
			:icon="icon"
			:href="href"
			target="_blank"
			outline
			color="primary"
		/>
	</div>
</template>
